let counter = 0;
export default function useShowAndRemove(props, setAlerts) {
  return {
    show(alert) {
      let newAlert = {
        ...alert
      };
      newAlert.position = alert.position || props.position;
      setAlerts(prevAlerts => {
        const key = alert.key || `tui-alert-card-${counter++}`;
        newAlert.key = key;
        let updatedAlerts = [];
        let alertIndex = -1;
        if (prevAlerts) {
          alertIndex = prevAlerts.findIndex(v => v.key === key);
          updatedAlerts = prevAlerts.concat();
        }
        if (alertIndex !== -1) {
          updatedAlerts.splice(alertIndex, 1, newAlert);
        } else {
          updatedAlerts.push(newAlert);
        }
        return updatedAlerts;
      });
    },
    remove(key) {
      setAlerts(prevAlerts => {
        return prevAlerts.filter(alert => alert.key !== key);
      });
    }
  };
}
//# sourceMappingURL=useShowAndRemove.js.map